import React ,{useEffect,useState} from "react";
import "./RoHistory.scss";
import { getRoStatusName } from "../../utils/common";
import dashboardApi from "../../services/dashboardApi";
import defaultImage from "../../assets/images/default-profile.png";

const RoHistory = ({repairOrderId}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [historyData, setHistoryData] = useState(null);

  const fetchData = async () => {
    try {     
      const response = await dashboardApi.getRoTaskHistory(repairOrderId); 
      setHistoryData(response?.data?.ROHistory);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="ro-history">
      {historyData?.length ? (    historyData?.map((history, index) => (
        <div className="history-row">
          <div className="history-head">
            <div className="stage-icon">
              <img src={BASE_URL+history.stageDetails[0].stageImagePath} alt="" />
            </div>
            <div className="stage-head">{history.stageDetails[0].roStageName}</div>
          </div>
          <div className="history-details-row">
            {/* Map through the tasks */}
            {history?.tasks?.map((task, taskIndex) => (
            <div className="history-details">
              <div className="user-details">
                <div className="user-img">
                  <img src={BASE_URL+task.technician.profileImagePath } alt="" onError={(e)=> e.target.src=defaultImage}/>
                </div>
                <div className="details">
                  <div className="name">{`${task.technician.firstName} ${task.technician.lastName}`}</div>
                  <div className="time">{`${task.duration} hours`}</div>
                  <div className="date">{new Date(task.taskWorkingDate).toLocaleDateString("en-GB", {
  timeZone: "UTC", // Ensure UTC is used
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
})}</div>
                </div>
              </div>
              <div className="work-status not-started">{getRoStatusName(task.taskStatus)}</div>
            </div>
            ))}           
          </div>
        </div>
      ))):<p className="nohistory">History data not found.</p>}      
    </div>
  );
};

export default RoHistory;
